import React, { useState, useEffect } from 'react';
import SelectInput from '../../form/select'
import { useSelector, useDispatch } from 'react-redux';
import {Request} from "../../../helpers/request";

export default function Step1() {
  const { currentStep, error, data } = useSelector(state => state.createPersona);
  const [ industry, setIndustry ] = useState(data.industry);
  const [ industries, setIndustries ] = useState([]);
  const [ subIndustries, setSubIndustries ] = useState([]);
  const [ subIndustry, setSubIndustry ] = useState(data.subIndustry);
  const selectedIndustry = industries.find(record => record.value === industry);
  const [apiResponse, setApiResponse] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    Request({ method: 'GET', url: '/brandwatch/industries'}).then(response => {
      console.log(response)
      setApiResponse(response);
      setIndustries(response.map(industry => {
        return { label: industry.name, value: industry.id }
      }))
    })
  }, []);

  const onIndustrySelect = (industry) => {
    let sub_industries = apiResponse.find(record => record.id === industry.value).sub_industries;
    setIndustry(industry);
    if (sub_industries === null) return;
    setSubIndustries(apiResponse.find(record => record.id === industry.value).sub_industries.map(child => {
      return { label: child.name, value: child.id }
    }));
  };

  const submit = () => {
    if (!industry) dispatch({ type: 'SET_ERROR', payload: 'please select industry !'});
    else {
      dispatch({ type: 'SET_DATA', payload: {...data, industry, subIndustry }});
      dispatch({ type: 'NEXT_STEP', payload: currentStep+1 })
    }
  };

  return (
    <>
    {currentStep === 1 && <React.Fragment>
      <p className="title mb-10">What is your industry?</p>

      <p className="mb-30 text-tuna">The better you specify it, the more accurate Lussy.io generates your personas.</p>

      <div className="mx-auto" style={{ maxWidth: '370px' }}>
        <div className="mb-20">
          <SelectInput
            placeholder="Industry"
            className="react-select"
            options={industries}
            name="industry"
            onChange={onIndustrySelect}
            value={selectedIndustry && selectedIndustry.label}
            required
          />
        </div>

        {subIndustries.length > 0 && <div className="mb-20">
          <SelectInput
            placeholder="Sub Industry"
            className="react-select"
            options={subIndustries}
            name="industry"
            onChange={setSubIndustry}
            isMulti
          />
        </div>}

        {error && <p className="mb2 text-violet-red">{error}</p>}

        <input
          type='button'
          onClick={submit}
          className="btn btn--primary col-12 mb-10"
          value="Next"
        />
      </div>
    </React.Fragment>}
    </>
  )
}